import { z } from "zod";
import {
  App,
  routes as allRoutes,
  fullEndpoints,
} from "@songtradr-sso/shared/common";
import {
  staticText as sharedText,
  verificationCodeSchema,
} from "@songtradr-sso/shared/frontend";
import { Api } from "../../shared/utils/api.utils";

// TEXT
const text = { shared: { inputs: sharedText.inputs } };

// STYLES

// DATA
export const exchangeTempTokenPostMfa = async (
  tempToken: string,
  mfa_confirm_code: string,
) => {
  await Api.request({
    method: "POST",
    url: endpoints.exchangeTempTokenPostMFA,
    data: {
      tempToken,
      mfa_confirm_code,
    },
  });

  sessionStorage.removeItem("auth_tmp");
  sessionStorage.removeItem("phone_digits");
};

// TYPES
export type FormFields = z.infer<typeof schema>;

// CONSTANTS
export const routes = allRoutes[App.Core];
const endpoints = fullEndpoints[App.Core].auth;

export const schema = z.object({
  [text.shared.inputs.verificationCode.id]: verificationCodeSchema,
});

// FUNCTIONS

// ASSETS
